import { v4 as uuidv4 } from 'uuid'
import { IAnalyticsServiceConfiguration } from '../..'
import { GlobalDataFormatter } from '../../../../domain/analytics/providers/global-data'
import { sha256 } from '../../../../utils/common/hash-code'
import { DOMUtils } from '../../../../utils/dom'
import { IdentityEvent } from '../../../common/events/identity'
import { PermutiveKeysMapping, PermutivePageviewAttributes } from '../../formatters/permutive-keys'

declare let window: any

export class Permutive {
    /**
     * Initialize Permutive
     */
    public init(organizationId: string, workspaceId: string, workspaceApiKey: string): void {
        if (!window.permutive && organizationId && workspaceId && workspaceApiKey) {
            const permutive = window.permutive || {}
            permutive.q= []
            permutive.config= {}
            permutive.config.apiKey= workspaceApiKey
            permutive.config.workspaceId=workspaceId
            permutive.config.viewId = uuidv4()
            permutive.config.environment = 'production'

            const o = ['addon', 'identify', 'track', 'trigger', 'query', 'segment',
                 'segments', 'ready', 'on', 'once', 'user', 'consent']
            for (const r of o) {
                permutive[r] = (...args: any[]): void => {
                    const i = Array.prototype.slice.call(args, 0)
                    permutive.q.push({
                        arguments: i,
                        functionName: r
                    })
                }
            }
            window.permutive = permutive
            // send mp_id to Permutive
            addEventListener(IdentityEvent.MP_READY, (e: any) => {
                if (e.detail.mpId) {
                    window.permutive.identify([{
                        id: e.detail.mpId,
                        tag: 'mpId'
                    }])
                }
            })
            // send hashed email to Permutive
            addEventListener(IdentityEvent.IDENTITY_INIT, (e: any) => {
                if (e.detail.email) {
                    sha256(e.detail.email)
                        .then((emailSha256) => {
                            window.permutive.identify([{
                                id: emailSha256,
                                tag: 'email_sha256'
                            }])
                        })
                        .catch((error: any) => {
                            console.error('email_sha256 error', error)
                        })
                }
            })
        }
    }

    public sendPageViewEvent(metaProperties?: IAnalyticsServiceConfiguration) {
        /**
         * Send Page View event
         */
        if (window.permutive) {
            const eventdata = this.getEventData(metaProperties, PermutivePageviewAttributes)
            // Add custom event to pageview event
            window.permutive.addon('web', {
                page:{...eventdata}
            })
            const workspaceId = window.permutive.config.workspaceId
            // Load permutive script
            DOMUtils.loadScript(`https://${workspaceId}.edge.permutive.app/${workspaceId}-web.js`)

            // add permutive to googletag
            window.googletag=window.googletag||{}
            window.googletag.cmd=window.googletag.cmd||[]
            /* istanbul ignore next */
            window.googletag.cmd.push((): void => {
                if(0===window.googletag.pubads().getTargeting('permutive').length) {
                    const e=window.localStorage.getItem('_pdfps')
                    window.googletag.pubads().setTargeting('permutive',e?JSON.parse(e):[])
                    const permutiveId=window.localStorage.getItem('permutive-id')
                    if (permutiveId) {
                        window.googletag.pubads().setTargeting('puid',permutiveId)
                        window.googletag.pubads().setTargeting('ptime',Date.now().toString())
                    }
                    if (window.permutive.config.viewId) {
                        window.googletag.pubads().setTargeting('prmtvvid',window.permutive.config.viewId)
                    }
                    if (window.permutive.config.workspaceId) {
                        window.googletag.pubads().setTargeting('prmtvwid',window.permutive.config.workspaceId)
                    }
                }
            })
        }
    }
    // send events with attributes to Permutive
    public sendEvent(eventType: string,eventData: any) {
        if(window.permutive) {
            window.permutive.track(eventType, eventData)
        }
    }
    public getEventData( metaProperties: any, dataAttrs: string[], commonData?: {}, customData?: {}): any {
        /**
         *  get Event key/value data
         */
        let eventData: any = { ...commonData}  // extra data common to all providers

        // Get Data Values ( this.metaProperties this is data coming from page-data )
        const globalFormatter = new GlobalDataFormatter(metaProperties)
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr)
                if(attrValue !== '' && attrValue.length > 0) {
                    eventData[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error in tags.Permutive', e)
            }
        })

        if(customData) {
            eventData = {
                ...eventData,
                ...customData
            }
        }

        // Update keys names
        for(const mappedKey in PermutiveKeysMapping) {
            if (mappedKey in eventData) {
                eventData[PermutiveKeysMapping[mappedKey]] = eventData[mappedKey]
                delete eventData[mappedKey]
            }
        }
        return eventData
    }
}
